import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const adminRemoveDependent = info =>
  call(websocketFetch, 'admin_remove_dependent', info);
